export const isAbortError = (e: any): boolean => {
  if (e === "Abort") return true;
  if (e?.name === "AbortError") return true;
  return false;
};
